module.exports = __webpack_public_path__ + "img/optimization-selection.2883f97a.svg";